module.exports = __webpack_public_path__ + "static/media/shop_type_5.2a0c4745.png";